import React, { Component } from 'react';
import './App.css';
import HotAuthTigger from './containers/HotAuthTigger';
import HotspotAuth from './containers/HotspotAuth';
import Publicity from './containers/Publicity';
import Cookies from 'universal-cookie';
import { hotjar } from 'react-hotjar';
import ReactGA from 'react-ga';
import axios from 'axios'

/* 
 * A troca da imagem de fundo, habilitação da captura de 
 * e-mail e plugin do facebook, são configurados no arquivo 
 * 'config.yml' em '../../Hotspot-API'
 */

let initRoute = false
/* ROTAS:
   false -> para iniciar normalmente

  'AuthError'
  'InsertPhone'
  'LoadingEnviandoSMS'
  'InserCode'
  'LoadingVerificandoSMS'
  'AuthOK'
  'Terms'
*/

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      readyToValenetWorld: false,
      envObj: null,
    }

    // axios.get('http://localhost:10088/config-yml?env=' + document.location.href.split('/')[3]).then(res => {
    axios.get('http://hotspot.valenet.io/api/config-yml?env=' + document.location.href.split('/')[3]).then(res => {
      this.setState({ envObj: res.data })
    })

  }

  componentDidMount() {
    //hotjar.initialize(1330425, 6);
  }

  componentWillMount() {
    ReactGA.initialize('UA-77347497-6');
    ReactGA.pageview(window.location.pathname + window.location.search);

    //hotjar.initialize(1330425, 6);
  }

  onAuthInit = () => {
    this.setState({
      initialized: true,
    })
  }

  gotoValenetWorld = () => {
    this.setState({
      readyToValenetWorld: true,
    })
  }

  render() {
    if (initRoute === false)
      return (
        <React.Fragment>

          {this.renderPublicity()}
          {this.renderAuthViews()}
        </React.Fragment>
      )

    else if (this.state.envObj)
      return (
        <div className="ha-cc">
          <HotspotAuth onReady={this.gotoValenetWorld} initRoute={initRoute} envObj={this.state.envObj} />
        </div>
      )
    else
      return (
        <div className="ha-cc"></div>
      )
  }

  renderAuthViews() {
    const { initialized, readyToValenetWorld } = this.state;
    if (initialized && !readyToValenetWorld) {
      return (
        <div className="ha-cc">
          <HotspotAuth onReady={this.gotoValenetWorld} initRoute={initRoute} envObj={this.state.envObj} />
        </div>
      )
    }
  }

  renderPublicity() {
    const { initialized } = this.state;

    if (!initialized && this.state.envObj) {
      return (
        <div>
          <div className="ha-pub" >
            <Publicity ancoragem={'height'} envObj={this.state.envObj} />
          </div>
          <div className="ha-c" >
            <HotAuthTigger onClick={this.onAuthInit} />
          </div>
        </div>
      )
    } else if (this.state.envObj) {
      return (
        <div className="ha-pub" >
          <Publicity ancoragem={'height'} envObj={this.state.envObj} />
        </div>
      )
    }
  }

  renderAuthTigger() {
    const { initialized } = this.state;
    if (!initialized) {
      return (
        <div className="ha-c">
          <HotAuthTigger onClick={this.onAuthInit} />
        </div>
      )
    }
  }
}

export default App;
